import { DatePicker } from "@mui/x-date-pickers";
import { addDays, isAfter, isValid } from "date-fns";
import { useField, useFormikContext } from "formik";

const FormikDatePicker = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue, setFieldTouched } = useFormikContext();
  const { callback, maxDaysFromToday, maxDate: maxDateProp, size, fullWidth, ...datePickerProps } = props;

  const handleChange = (value) => {
    if (maxDaysFromToday >= 0 && value && isValid(value)) {
      const maxAllowedDate = addDays(new Date(), maxDaysFromToday);

      if (isAfter(value, maxAllowedDate)) {
        return;
      }
    }

    if (maxDateProp && value && isValid(value) && isAfter(value, maxDateProp)) {
      return;
    }

    setFieldValue(props.name, value);
    if (callback) {
      callback(value);
    }
  };
  const maxDate = maxDateProp || (maxDaysFromToday >= 0 ? addDays(new Date(), maxDaysFromToday) : undefined);

  const value = field.value ? new Date(field.value) : null;

  return (
    <DatePicker
      value={value}
      onChange={handleChange}
      format="dd/MM/yyyy"
      maxDate={maxDate}
      {...datePickerProps}
      slotProps={{
        textField: {
          onBlur: () => setFieldTouched(props.name, true),
          variant: "standard",
          fullWidth: fullWidth || false,
          size: size || "medium",
          error: meta.touched && meta.error ? true : false,
          helperText: meta.touched && meta.error ? meta.error : null,
        }
      }}
      error={meta.touched && meta.error ? true : false}
      helperText={meta.touched && meta.error ? meta.error : null}
    />
  );
};

export default FormikDatePicker;
